<modal-panel title="Filter ADX-ERP Report" (close)="close()">
  <div class="filter" [formGroup]="form">

    <div class="filter__section">
      <div class="filter__section-title">Invoice</div>
      <div class="filter__fields" [class.two-col]="!isSmall">

        <mat-form-field>
          <mat-label>ADX Invoice ID</mat-label>
          <input matInput type="number" formControlName="AdxInvoiceId" placeholder="e.g. 12345"/>
        </mat-form-field>

        <mat-form-field>
          <mat-label>ADX Reference (Record Locator)</mat-label>
          <input matInput formControlName="RecordLocator" placeholder="e.g. ABCDEF"/>
        </mat-form-field>

        <mat-form-field data-testid="adx-erp-filter-modal-invoice-group-field">
          <mat-label>Invoice Group</mat-label>
          <input matInput formControlName="InvoiceGroup" placeholder="e.g. TE BUNDLE"/>
        </mat-form-field>

        <mat-form-field data-testid="adx-erp-filter-modal-data-source-field">
          <mat-label>Data Source</mat-label>
          <mat-select formControlName="DataSourceId" data-testid="adx-erp-filter-modal-data-source-field-select">
            <mat-option [value]="null">All</mat-option>
            @for (dataSource of dataSources$ | async; track dataSource.id) {
              <mat-option [value]="dataSource.id">{{ dataSourceLabel(dataSource) }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-label>ADX Created From</mat-label>
          <input matInput readonly [matDatepicker]="createdFrom" formControlName="CreatedDateFrom"/>
          <mat-hint>MM/DD/YYYY</mat-hint>
          <mat-datepicker #createdFrom/>
          <mat-datepicker-toggle matIconSuffix [for]="createdFrom"/>
        </mat-form-field>

        <mat-form-field>
          <mat-label>ADX Created To</mat-label>
          <input matInput readonly [matDatepicker]="createdTo" formControlName="CreatedDateTo"/>
          <mat-hint>MM/DD/YYYY</mat-hint>
          <mat-datepicker #createdTo/>
          <mat-datepicker-toggle matIconSuffix [for]="createdTo"/>
        </mat-form-field>

        <div class="autocomplete-field" data-testid="adx-erp-filter-modal-profile-name-field">
          <dynamic-autocomplete
            formControlName="ClientName"
            tableName="Client"
            columnName="ProfileName"
            formLabel="Client Name"
            [emitString]="true"
            dataTestId="adx-erp-filter-modal-profile-name"/>
        </div>
      </div>
    </div>

    <div class="filter__section">
      <div class="filter__section-title">Bookings</div>
      <div class="filter__fields" [class.two-col]="!isSmall">

        <mat-form-field data-testid="adx-erp-filter-modal-travel-type-field">
          <mat-label>Travel Type</mat-label>
          <mat-select formControlName="TravelTypeId" data-testid="adx-erp-filter-modal-travel-type-field-select">
            <mat-option [value]="null">All</mat-option>
            @for (travelType of travelTypes$ | async; track travelType.id) {
              <mat-option [value]="travelType.id">{{ travelType.travelTypeName }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field data-testid="adx-erp-filter-modal-external-travel-service-type-field">
          <mat-label>External Travel Service Type</mat-label>
          <mat-select formControlName="ExternalTravelServiceTypeId"
                      data-testid="adx-erp-filter-modal-external-travel-service-type-field-select">
            <mat-option [value]="null">All</mat-option>
            @for (externalType of externalTravelServiceTypes$ | async; track externalType.id) {
              <mat-option [value]="externalType.id">{{ externalType.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <div class="autocomplete-field" data-testid="adx-erp-filter-modal-vendor-name-field">
          <dynamic-autocomplete
            formControlName="VendorName"
            tableName="Vendor"
            columnName="VendorName"
            formLabel="Vendor Name"
            [emitString]="true"
            dataTestId="adx-erp-filter-modal-vendor-name"/>
        </div>

        <div class="autocomplete-field" data-testid="adx-erp-filter-modal-agent-name-field">
          <dynamic-autocomplete
            formControlName="AgentName"
            tableName="Agent"
            columnName="AgentName"
            formLabel="Agent Name"
            [emitString]="true"
            dataTestId="adx-erp-filter-modal-agent-name"/>
        </div>

        <div class="radio-filter-wrapper" data-testid="adx-erp-filter-modal-is-mor-field">
          <div class="radio-header">
            <span class="radio-label" data-testid="adx-erp-filter-modal-is-mor-field-label">MOR?</span>
            <button
              id="adx-erp-is-mor-clear-filter-button"
              mat-icon-button
              type="button"
              class="clear-icon-btn"
              (click)="clearIsMorFilter()">
              <mat-icon>close</mat-icon>
            </button>
          </div>

          <mat-radio-group formControlName="IsMor" aria-label="is-mor" color="primary" class="radio-group">
            <mat-radio-button [value]="true">Yes</mat-radio-button>
            <mat-radio-button [value]="false">No</mat-radio-button>
          </mat-radio-group>
        </div>

      </div>
    </div>

    <div class="filter__section">
      <div class="filter__section-title">ERP</div>
      <div class="filter__fields" [class.two-col]="!isSmall">
        <mat-form-field>
          <mat-label>Sent to ERP From</mat-label>
          <input matInput readonly [matDatepicker]="erpSentFrom" formControlName="ErpSentDateFrom"/>
          <mat-hint>MM/DD/YYYY</mat-hint>
          <mat-datepicker #erpSentFrom/>
          <mat-datepicker-toggle matIconSuffix [for]="erpSentFrom"/>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Sent to ERP To</mat-label>
          <input matInput readonly [matDatepicker]="erpSentTo" formControlName="ErpSentDateTo"/>
          <mat-hint>MM/DD/YYYY</mat-hint>
          <mat-datepicker #erpSentTo/>
          <mat-datepicker-toggle matIconSuffix [for]="erpSentTo"/>
        </mat-form-field>

        <mat-form-field>
          <mat-label>ERP Response From</mat-label>
          <input matInput readonly [matDatepicker]="erpRespFrom" formControlName="ErpResponseDateFrom"/>
          <mat-hint>MM/DD/YYYY</mat-hint>
          <mat-datepicker #erpRespFrom/>
          <mat-datepicker-toggle matIconSuffix [for]="erpRespFrom"/>
        </mat-form-field>

        <mat-form-field>
          <mat-label>ERP Response To</mat-label>
          <input matInput readonly [matDatepicker]="erpRespTo" formControlName="ErpResponseDateTo"/>
          <mat-hint>MM/DD/YYYY</mat-hint>
          <mat-datepicker #erpRespTo/>
          <mat-datepicker-toggle matIconSuffix [for]="erpRespTo"/>
        </mat-form-field>

        <mat-form-field>
          <mat-label>ERP Sales Order</mat-label>
          <input matInput formControlName="ErpOrderNumber" placeholder="e.g. SO-000123"/>
        </mat-form-field>
      </div>
    </div>

  </div>
  <ng-container modalPanelFooter>
    <button mat-button (click)="reset()">Reset</button>
    <button mat-raised-button color="primary" (click)="apply()">Apply</button>
  </ng-container>
</modal-panel>
